import { Home, FileText, TrendingUp } from "lucide-react";
import { useStaggeredAnimation } from "@/hooks/useScrollAnimation";

const ConsumerTargetAudience = () => {
  const { ref, visibleItems } = useStaggeredAnimation<HTMLDivElement>(3, 150);

  const audiences = [
    {
      icon: Home,
      title: "Homeowners",
      description: "Looking to sell without paying agent commissions while still getting professional marketing"
    },
    {
      icon: FileText,
      title: "FSBO Sellers",
      description: "Want professional marketing and access to buyer networks without the cost"
    },
    {
      icon: TrendingUp,
      title: "Motivated Sellers",
      description: "Need a fast sale and have flexible pricing - connect with cash buyers quickly"
    }
  ];

  return (
    <section className="py-20 px-4 bg-gray-900/30">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Who This Is For</h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Perfect for homeowners who want professional marketing without the traditional costs
          </p>
        </div>
        
        <div ref={ref} className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className={`bg-gray-800 border border-gray-700 rounded-lg p-8 text-center transition-all duration-500 ${
                visibleItems.includes(index) ? 'animate-scale-in' : 'opacity-0 scale-95'
              }`}
            >
              <div className="w-16 h-16 bg-[#ffd700]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <audience.icon className="h-8 w-8 text-[#ffd700]" />
              </div>
              <h3 className="text-2xl font-semibold mb-3">{audience.title}</h3>
              <p className="text-gray-400">{audience.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConsumerTargetAudience;
